module.exports = __webpack_public_path__ + "img/children-group.b8c9ada3.png";